export const PAGE_SIZE = 10;

export const emptyQuotationItem = {
  description: "",
  qty: "",
  rate: "",
  unit: "",
};

export const emptyQuotationForm = {
  quotationNo: "",
  billTitle: "",
  companyName: "",
  date: new Date().toISOString().slice(0, 10), // yyyy-mm-dd for <input type="date">
  items: [{ ...emptyQuotationItem }],
};

export const getItemAmount = (item) => {
  const qty = Number(item.qty);
  const rate = Number(item.rate);
  if (!Number.isFinite(qty) || !Number.isFinite(rate)) return 0;
  return Math.round(qty * rate * 100) / 100;
};

export const getQuotationTotal = (items = []) =>
  items.reduce((sum, item) => sum + getItemAmount(item), 0);

export const buildQuotationValidationMessage = (form) => {
  if (
    !Number.isInteger(Number(form.quotationNo)) ||
    Number(form.quotationNo) < 1
  ) {
    return "A valid quotation number is required.";
  }

  if (!String(form.billTitle ?? "").trim()) {
    return "Bill title is required.";
  }

  if (!String(form.companyName ?? "").trim()) {
    return "Company name is required.";
  }

  if (!Array.isArray(form.items) || form.items.length === 0) {
    return "At least one product item is required.";
  }

  if (!String(form.date ?? "").trim()) {
    return "Date is required.";
  }

  const invalidItem = form.items.find(
    (item) =>
      !String(item.description ?? "").trim() ||
      !Number.isInteger(Number(item.qty)) ||
      Number(item.qty) < 1 ||
      !Number.isFinite(Number(item.rate)) ||
      Number(item.rate) < 0 ||
      !String(item.unit ?? "").trim(),
  );
  if (invalidItem) {
    return "Each product row needs a description, quantity, rate, and unit.";
  }

  return "";
};
